import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import player from 'lottie-web';
import { LottieComponent, provideLottieOptions } from 'ngx-lottie';
import { ValidationService } from '../+validation/services/validation.service';
import { ValidationModule } from '../+validation/validation.module';
import { ResourceService } from '../services/resource.service';
import { TicketService } from '../services/ticket.service';
import { ViewportService } from '../services/viewport.service';
import { AddressComponent } from './components/address.component/address.component';
import { BasketAddedElementComponent } from './components/basket-added-element.component/basket-added-element.component';
import { BasketPurchaseComponent } from './components/basket-purchase.component/basket-purchase.component';
import { BasketShellPurchaseComponent } from './components/basket-shell-purchase.component/basket-shell-purchase.component';
import { BasketShellComponent } from './components/basket-shell.component/basket-shell.component';
import { BasketComponent } from './components/basket.component/basket.component';
import { BreadcrumbsComponent } from './components/breadcrumbs.component/breadcrumbs.component';
import { ButtonSpinnerComponent } from './components/button-spinner.component/button-spinner.component';
import { CarouselComponent } from './components/carousel.component/carousel.component';
import { CheckmarkComponent } from './components/checkmark.component/checkmark.component';
import { CountdownContainerComponent } from './components/countdown-container.component/countdown-container.component';
import { CountdownNextDrawComponent } from './components/countdown-next-draw.component/countdown-next-draw.component';
import { CountdownTicketWinHistoryComponent } from './components/countdown-sale-stop-urgency.component/countdown-ticket-win-history.component';
import { CountdownSaleStopComponent } from './components/countdown-sale-stop.component/countdown-sale-stop.component';
import { CountdownV2Component } from './components/countdown-v2.component/countdown-v2.component';
import { CountdownV3Component } from './components/countdown-v3.component/countdown-v3.component';
import { CountdownComponent } from './components/countdown.component/countdown.component';
import { CprComponent } from './components/cpr.component/cpr.component';
import { DdkSpinnerComponent } from './components/ddk-spinner.component/ddk-spinner.component';
import { DescriptionCardsComponent } from './components/description-cards.component/description-cards.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { ErrorComponent } from './components/error.component/error.component';
import { LottieFile } from './components/lottie-file.component/lottie-file.component';
import { AgeRestrictionModalComponent } from './components/modals/age-restriction-modal.component/age-restriction-modal.component';
import { BankInfoModalComponent } from './components/modals/bank-info-modal.component/bank-info-modal.component';
import { ConfirmRemoveModalComponent } from './components/modals/confirm-remove-modal.component/confirm-remove-modal.component';
import { DrawInfoModalComponent } from './components/modals/draw-info-modal.component/draw-info-modal.component';
import { HowToPlayModalComponent } from './components/modals/how-to-play-modal.component/how-to-play-modal.component';
import { InfoPersonalDetailsModalComponent } from './components/modals/info-personal-details.component/info-personal-details.component';
import { LoginNeededModalComponent } from './components/modals/login-needed-modal.component/login-needed-modal.component';
import { ModalComponent } from './components/modals/modal.component/modal.component';
import { NetsPayment3dNotificationModalComponent } from './components/modals/nets-payment-3d-notification-modal.component/nets-payment-3d-notification-modal.component';
import { NetsPaymentCancelledModalComponent } from './components/modals/nets-payment-cancelled-modal.component/nets-payment-cancelled-modal.component';
import { NetsPaymentDeclinedModalComponent } from './components/modals/nets-payment-declined-modal.component/nets-payment-declined-modal.component';
import { OrderEmptyModalComponent } from './components/modals/order-empty-modal.component/order-empty-modal.component';
import { OrderExpiredModalComponent } from './components/modals/order-expired-modal.component/order-expired-modal.component';
import { OrderFullModalComponent } from './components/modals/order-full-modal.component/order-full-modal.component';
import { PaymentRejectedModalComponent } from './components/modals/payment-rejected-modal.component/payment-rejected-modal.component';
import { PlayerExistsModalComponent } from './components/modals/player-exists-modal.component/player-exists-modal.component';
import { ProductChangeModalComponent } from './components/modals/product-change-modal.component/product-change-modal.component';
import { ProductInfoModalComponent } from './components/modals/product-info-modal.component/product-info-modal.component';
import { RequestSignoutModalComponent } from './components/modals/request-signout-modal.component/request-signout-modal.component';
import { SaleStopReachedModalComponent } from './components/modals/salestop-reached-modal.component/salestop-reached-modal.component';
import { SecurePayModalComponent } from './components/modals/secure-pay-modal.component/secure-pay-modal.component';
import { WelcomeModalSimpleComponent } from './components/modals/welcome-modal-simple.component/welcome-modal-simple.component';
import { NavigationCardsComponent } from './components/navigation-cards.component/navigation-cards.component';
import { NetaxeptPaymentComponent } from './components/netaxept-payment.component/netaxept-payment.component';
import { NotificationComponent } from './components/notification.component/notification.component';
import { OpeningHoursSupportComponent } from './components/opening-hours-support.component/opening-hours-support.component';
import { OpeningHoursComponent } from './components/opening-hours.component/opening-hours.component';
import { OrderlineListComponent } from './components/orderline-list.component/orderline-list.component';
import { PlayingMonthsComponent } from './components/playing-months/playing-months.component';
import { PricingUpdateComponent } from './components/pricing-update.component/pricing-update.component';
import { SpinnerComponent } from './components/spinner.component/spinner.component';
import { TicketCardComponent } from './components/ticket-card.component/ticket-card.component';
import { UrgencyCountdownV2Component } from './components/urgency-countdown-v2.component/urgency-countdown-v2.component';
import { WoopBackgroundComponent } from './components/woop-background.component/woop-background.component';
import { InputEmailConfirmationDirective } from './directive/input-email-confirmation.directive';
import { InputEmailDirective } from './directive/input-email.directive';
import { NumberInputDirective } from './directive/number-input.directive';
import { StayingAliveDirective } from './directive/staying-alive.directive';
import { TicketNumberInputDirective } from './directive/ticket-number-input.directive';
import { CreditCardPipe } from './pipes/credit-card.pipe';
import { MoneyPipe } from './pipes/money.pipe';
import { ResourcePipe } from './pipes/resource.pipe';
import { RichUrlPipe } from './pipes/rich-url.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { ShareTypeNamePipe } from './pipes/share-type-name.pipe';
import { TicketWinEventFullPrizePipe } from './pipes/ticket-win-event-full-prize.pipe';
import { NotificationService } from './services/notification.service';

// Export this factory to be used by ngx-lottie
export function playerFactory() {
  return player;
}
@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule,
    LottieComponent,
    ValidationModule,
    ReactiveFormsModule,
  ],
  declarations: [
    AddressComponent,
    AgeRestrictionModalComponent,
    BasketAddedElementComponent,
    BasketComponent,
    BasketPurchaseComponent,
    BasketShellComponent,
    BasketShellPurchaseComponent,
    BreadcrumbsComponent,
    ButtonSpinnerComponent,
    CarouselComponent,
    CheckmarkComponent,
    CountdownComponent,
    CountdownContainerComponent,
    CountdownNextDrawComponent,
    CountdownSaleStopComponent,
    CountdownTicketWinHistoryComponent,
    CountdownV2Component,
    CountdownV3Component,
    CprComponent,
    CreditCardPipe,
    DdkSpinnerComponent,
    DescriptionCardsComponent,
    ErrorComponent,
    HowToPlayModalComponent,
    BankInfoModalComponent,
    InputEmailConfirmationDirective,
    InputEmailDirective,
    LoginNeededModalComponent,
    ModalComponent,
    MoneyPipe,
    NavigationCardsComponent,
    NetaxeptPaymentComponent,
    NetsPayment3dNotificationModalComponent,
    NetsPaymentCancelledModalComponent,
    NetsPaymentDeclinedModalComponent,
    ProductChangeModalComponent,
    NotificationComponent,
    NumberInputDirective,
    OpeningHoursComponent,
    OpeningHoursSupportComponent,
    OrderEmptyModalComponent,
    OrderExpiredModalComponent,
    OrderFullModalComponent,
    PaymentRejectedModalComponent,
    PlayerExistsModalComponent,
    PlayingMonthsComponent,
    PricingUpdateComponent,
    ProductInfoModalComponent,
    RequestSignoutModalComponent,
    ResourcePipe,
    RichUrlPipe,
    SafePipe,
    SaleStopReachedModalComponent,
    SecurePayModalComponent,
    ShareTypeNamePipe,
    StayingAliveDirective,
    TicketCardComponent,
    TicketNumberInputDirective,
    UrgencyCountdownV2Component,
    WelcomeModalSimpleComponent,
    ConfirmRemoveModalComponent,
    InfoPersonalDetailsModalComponent,
    LottieFile,
    WoopBackgroundComponent,
    ErrorMessageComponent,
    OrderlineListComponent,
    SpinnerComponent,
    TicketWinEventFullPrizePipe,
    DrawInfoModalComponent
  ],
  providers: [
    DatePipe,
    NotificationService,
    ResourceService,
    TicketService,
    ValidationService,
    ViewportService,
    provideLottieOptions({
      player: () => import('lottie-web'),
    })
  ],
  exports: [
    AddressComponent,
    AgeRestrictionModalComponent,
    BasketAddedElementComponent,
    BasketComponent,
    BasketPurchaseComponent,
    BasketShellComponent,
    BasketShellPurchaseComponent,
    BreadcrumbsComponent,
    ButtonSpinnerComponent,
    CarouselComponent,
    CheckmarkComponent,
    CountdownComponent,
    CountdownContainerComponent,
    CountdownNextDrawComponent,
    CountdownSaleStopComponent,
    CountdownTicketWinHistoryComponent,
    CountdownV2Component,
    CprComponent,
    CreditCardPipe,
    DdkSpinnerComponent,
    DescriptionCardsComponent,
    HowToPlayModalComponent,
    BankInfoModalComponent,
    InputEmailConfirmationDirective,
    InputEmailDirective,
    LoginNeededModalComponent,
    ModalComponent,
    MoneyPipe,
    NavigationCardsComponent,
    NetaxeptPaymentComponent,
    NetsPayment3dNotificationModalComponent,
    NetsPaymentDeclinedModalComponent,
    NotificationComponent,
    NumberInputDirective,
    OpeningHoursComponent,
    OpeningHoursSupportComponent,
    OrderEmptyModalComponent,
    OrderExpiredModalComponent,
    OrderFullModalComponent,
    PaymentRejectedModalComponent,
    PlayerExistsModalComponent,
    PricingUpdateComponent,
    ProductInfoModalComponent,
    RequestSignoutModalComponent,
    ResourcePipe,
    RichUrlPipe,
    SafePipe,
    SaleStopReachedModalComponent,
    SecurePayModalComponent,
    ShareTypeNamePipe,
    StayingAliveDirective,
    TicketCardComponent,
    TicketNumberInputDirective,
    UrgencyCountdownV2Component,
    WelcomeModalSimpleComponent,
    ConfirmRemoveModalComponent,
    InfoPersonalDetailsModalComponent,
    LottieFile,
    WoopBackgroundComponent,
    OrderlineListComponent,
    ErrorMessageComponent,
    ProductChangeModalComponent,
    SpinnerComponent,
    TicketWinEventFullPrizePipe,
    DrawInfoModalComponent
  ],
  schemas: [
    // lottie-web requires this to work with Angular. see lottie-file.component.ts
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule {}
